import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModuleVideo extends Component {

    render() {

        const { module } = this.props;

        return (
            <div className="col-sm-12">
                <h1 className="h1">{ module.name }</h1>
                <div className="embed-responsive embed-responsive-16by9">
                    <iframe id="player1" className="embed-responsive-item" src={ `${ module.live_video_url }` } allowFullScreen />
                </div>
            </div>
        );

    }

}

ModuleVideo.propTypes = {
    module: PropTypes.object.isRequired,
};

export default ModuleVideo;


// WEBPACK FOOTER //
// src/client/components/site/features/training/webinars/pages/elements/ModuleVideo.js